import React from "react"
import styled from "styled-components"

export default function MailTo() {
  const mailto = "mailto:rustichomesteadchile@gmail.com"

  const handleOnClick = () => {
    window.location = mailto
  }

  return (
    <Wrapper>
      <a href={mailto} onClick={handleOnClick}>
        Escribenos un mail
      </a>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  a:active {
    color: var(--black);
  }
  a:visited {
    color: var(--black);
  }
`
